module.exports = __webpack_public_path__ + "img/hyfx.54fd89d5.png";